/* eslint-disable no-nested-ternary */
const Days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// formatDateRange :: ISO8601 -> ISO8601 -> String
const formatDateRange = (startDate) => (endDate) => {
  const date1 = new Date(startDate);
  const date2 = new Date(endDate);

  return date1 && date2 ? [
    `${Months[date1.getMonth()]} ${date1.getDate()}`,
    date1.getMonth() !== date2.getMonth()
      ? ` - ${Months[date2.getMonth()]} ${date2.getDate()}`
      : date1.getDate() !== date2.getDate()
        ? `-${date2.getDate()}` : '',
    ', ',
    date2.getFullYear(),
  ].flat().join('') : 'N/A';
};

const formatDate = (iso8601, showWeekday = true) => {
  const date = new Date(iso8601);
  return showWeekday
    ? `${Days[date.getDay()]} - ${Months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
    : `${Months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};

export {
  formatDate,
  formatDateRange,
};
